"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Confirm = function (_a) {
    var isOpen = _a.isOpen, onClick = _a.onClick;
    return (react_1["default"].createElement(Dialog_1["default"], { open: isOpen },
        react_1["default"].createElement(DialogTitle_1["default"], null, "Delete"),
        react_1["default"].createElement(DialogContent_1["default"], null, "Are you sure you would like to delete this entry?"),
        react_1["default"].createElement(DialogActions_1["default"], null,
            react_1["default"].createElement(Button_1["default"], { autoFocus: true, onClick: function () {
                    onClick(true);
                }, color: "primary" }, "Delete"),
            react_1["default"].createElement(Button_1["default"], { onClick: function () { return onClick(false); }, color: "primary" }, "Cancel"))));
};
exports["default"] = Confirm;
